angular.module('vastdesk').
  component('globalFcapPixelSettings', {
    bindings: {},
    controller: ['$element', function($element) {
      var toggleAllowEmptyHouseholdId = function() {
        setTimeout(function() {
          var listType = $element.find('input[name*="[list_type]"]:checked').val();
          var isHouseholdId = listType === 'household_id';
          var wrapper = $element.find('.allow-empty-household-id');

          wrapper.toggleClass('hidden', !isHouseholdId);

          // make sure we're not sending allow-empty-household-id when listType is not household-id
          if (!isHouseholdId) {
            wrapper.find('input[type="checkbox"]').prop('checked', false);
          }
        }, 0);
      };

      $element.on('click', 'label', toggleAllowEmptyHouseholdId);

      this.$onInit = function() {
        toggleAllowEmptyHouseholdId();
      };
    }]
});
